import { t } from '@/i18n';
import { z } from 'zod';

/*
 These keys are defined at backend/bns/bns/utils/constants/codes.py
*/

export const apiErrorCodeType = z.enum([
  'BNS_API_COMMENTS_400_0001_COMMENT_API__NOT_FOUND_IN_INPUT_CANDIDATE',
  'BNS_API_COMMON_400_0001_INVALID_DATA',
  'BNS_API_COMMON_400_0002_UNIQUE_CONSTRAINT_ERROR',
  'BNS_API_COMMON_400_0003_FOREIGN_KEY_CONSTRAINT_ERROR',
  'BNS_API_COMMON_400_0005_DB_PROTECTED_ERROR',
  'BNS_API_COMMON_400_0007_DB_CODE_UNIQUE_VIOLATION_ERROR',
  'BNS_API_COMMON_400_0008_INVALID_URL',
  'BNS_API_COMMON_403_0001_NOT_PERMITTED',
  'BNS_API_COMMON_403_0002_IP_RESTRICTED',
  'BNS_API_COMMON_403_0003_LOGIN_TIME_RESTRICTED',
  'BNS_API_COMMON_404_0001_NOT_FOUND',
  'BNS_API_COMMON_500_0001_INTERNAL_SERVER_ERROR',
  'BNS_API_EXECUTIONS_400_0001_CREATE_CMS_NOTE_API__SLUG_DUPLICATED',
  'BNS_API_EXECUTIONS_400_0001_CREATE_EXECUTION_PROJECT_API__PROJECT_NOT_FOUND',
  'BNS_API_EXECUTIONS_400_0002_CREATE_EXECUTION_CART_API__EXECUTION_CART_IDENTIFIER_NOT_FOUND',
  'BNS_API_EXECUTIONS_400_0002_PATCH_CMS_NOTE_BULK_UPDATE_API__NOTE_NOT_FOUND',
  'BNS_API_EXECUTIONS_400_0003_CREATE_REVENUE_CHANGE_SOURCE_API__EXECUTION_CART_NOT_FOUND',
  'BNS_API_EXECUTIONS_400_0003_PATCH_CMS_NOTE_API__PARENT_NOTE_IS_NOT_PUBLISHED',
  'BNS_API_EXECUTIONS_400_0004_CREATE_EXECUTION_CART_API__EXPENDITURE_NATURE_NOT_FOUND',
  'BNS_API_INDICATORS_400_0001_INDICATOR_API__SAME_TITLE_EXISTS',
  'BNS_API_ORGANIZATIONS_400_0001_UPDATE_API__UPPER_ORGANIZATION_INCORRECT',
  'BNS_API_PROJECTS_400_0001_CONTINUE_API__NO_INITIAL_BUDGET',
  'BNS_API_PROJECTS_400_0002_CONTINUE_API__PROJECT_IS_CONTINUED',
  'BNS_API_PROJECTS_400_0006_SPLIT_API__PROJECT_IS_LOCKED',
  'BNS_API_PROJECTS_400_0007_MERGE_API__PROJECT_IS_LOCKED',
  'BNS_API_PROJECTS_400_0008_SPLIT_API__PROJECT_IS_NEW',
  'BNS_API_PROJECTS_400_0009_MERGE_API__PROJECT_IS_NEW',
  'BNS_API_PROJECTS_400_0010_MERGE_API__FISCAL_YEAR_MISMATCH',
  'BNS_API_PROJECTS_400_0011_MERGE_API__SHEET_TYPE_MISMATCH',
  'BNS_API_PROJECTS_400_0012_MERGE_API__SAME_PROJECT',
  'BNS_API_PROJECTS_400_0013_DELETE_API__PROJECT_RELATION_EXIST',
  'BNS_API_PROJECTS_400_0014_DECIDED_BUDGET_RELATED_API__DECIDED_BUDGET_BLOCK',
  'BNS_API_PROJECTS_400_0016_NOTIFIED_BUDGET_RELATED_API__NOTIFIED_BUDGET_BLOCK',
  'BNS_API_PROJECTS_400_0017_DECIDED_BUDGET_RELATED_API__DECIDE_BEFORE_NOTIFY',
  'BNS_API_PROJECTS_400_0018_DECIDED_BUDGET_RELATED_API__RESET_NOTIFY_WITH_DECIDED_BUDGET',
  'BNS_API_PROJECTS_400_0019_BATCH_API__SAME_BATCH_IS_RUNNING',
  'BNS_API_PROJECTS_400_0020_BUDGET_AGENDA_API__REQUESTING_BUDGET_BLOCK',
  'BNS_API_PROJECTS_400_0021_ACTIVITY_FLOW_MUST_BE_STARTED_FROM_ACTIVITY',
  'BNS_API_PROJECTS_400_0029_PUBLISH_API__WORKFLOW_IS_NOT_COMPLETED',
  'BNS_API_PROJECTS_400_0031_PROJECT_API__EXPENDITURE_CART_MUST_HAVE_AT_LEAST_ONE_EXPENDITURE_ITEM',
  'BNS_API_PROJECTS_400_0032_PROJECT_API__CANNOT_DELETE_EXPENDITURE_ITEM_BECAUSE_REVENUE_SOURCE_ITEM_EXISTS',
  'BNS_API_PROJECTS_400_0033_DECIDED_BUDGET_RELATED_API__RELATED_PROJECT_HAS_DELETED_USER',
  'BNS_API_PROJECTS_400_0034_NOTIFIED_BUDGET_API__REQUESTING_BUDGET_BLOCK',
  'BNS_API_PROJECTS_400_0035_PUBLISH_API__BUSINESS_MANAGER_DELETED',
  'BNS_API_PROJECTS_400_0036_PUBLISH_API__PEOPLE_IN_CHARGE_DELETED',
  'BNS_API_PROJECTS_400_0037_ANALYSIS_API__EXCEEDED_UPPER_LIMIT',
  'BNS_API_PROJECTS_400_0038_SUB_PROJECT_STATUS_UPDATE_ERROR__NOTIFIED_BUDGET_BLOCK',
  'BNS_API_PROJECTS_400_0039_SUB_PROJECT_STATUS_UPDATE_ERROR__NON_ZERO_LATEST_ASSESSMENT',
  'BNS_API_PROJECTS_400_0040_ASSESSMENT_DELETE_ERROR__NOT_ZERO_IN_DISCONTINUED_SUB_PROJECT',
  'BNS_API_PROJECTS_400_0041_CONTINUE_API__REVENUE_SOURCE_ITEM_IS_CONTINUED',
  'BNS_API_PROJECTS_400_0042_CONTINUE_API__REVENUE_SOURCE_TYPE_IS_NOT_GENERAL',
  'BNS_API_PROJECTS_400_0043_CONTINUE_API__BUDGET_STATUS_TYPE_IS_NOT_DECIDED',
  'BNS_API_PROJECTS_400_0044_SAVEPOINT_API_CREATE_ERROR__BUDGET_STATUS_HAS_ALREADY_BEEN_DECIDED',
  'BNS_API_PROJECTS_400_0045_DIFF_API__NO_VIEWABLE_PERMISSION',
  'BNS_API_PROJECTS_400_0046_CONTINUE_API__BUDGET_STATUS_TYPE_IS_DISCONTINUED',
  'BNS_API_PROJECTS_400_0047_EXPENDITURE_CART_API_CREATE_ERROR__EXCEEDS_THE_MAXIMUM_NUMBER_OF_CARTS',
  'BNS_API_PROJECTS_400_0048_SUB_PROJECT_API_MERGE_ERROR__EXCEEDS_THE_MAXIMUM_NUMBER_OF_CARTS',
  'BNS_API_PROJECTS_400_0049_NOTIFIED_BUDGET_API__NULL_ASSESSING_AMOUNT_PROJECT_BLOCK',
  'BNS_API_PROJECTS_400_0050_DISTRIBUTION_REQUEST_API__REQUESTED_AMOUNT_ALLOCATION_FAILED',
  'BNS_API_PROJECTS_400_0051_REVENUE_SOURCE_ITEM_CONTINUE_API__LOCKED_BY_BUDGET_STATUS',
  'BNS_API_PROJECTS_400_0052_NOTIFIED_BUDGET_API__NULL_ASSESSING_AMOUNT_REVENUE_SOURCE_ITEM_BLOCK',
  'BNS_API_PROJECTS_400_0053_NOTIFIED_BUDGET_API__THERE_ARE_DISTRIBUTION_REQUESTS_THAT_CANNOT_BE_CANCELED',
  'BNS_API_PROJECTS_400_0054_CARRIED_FORWARD_REQUEST_API__NO_PERMISSION_TO_UPDATE_STATUS',
  'BNS_API_PROJECTS_400_0055_CARRIED_FORWARD_REQUEST_API__STATUS_IS_NOT_CHANGED',
  'BNS_API_PROJECTS_400_0056_PROJECT_API__CANNOT_UPDATE_BASIC_INFO_WITHOUT_USER_ORGANIZATION_RELATION_TO_PROJECT',
  'BNS_API_PROJECTS_400_0057_CARRIED_FORWARD_REQUEST_API__NO_REGISTERED_CARRIED_FORWARD_AMOUNT',
  'BNS_API_PROJECTS_400_0060_REORGANIZE_SUB_PROJECT_API__PROJECT_IS_NOT_DECIDED',
  'BNS_API_PROJECTS_400_0061_REORGANIZE_SUB_PROJECT_API__ALL_SUB_PROJECTS_MOVED',
  'BNS_API_PROJECTS_400_0062_REORGANIZE_SUB_PROJECT_API__EXECUTION_CART_TRANSFER_FAILED',
  'BNS_API_PROJECTS_400_0063_REORGANIZE_SUB_PROJECT_API__CARRY_FORWARD_IS_SET',
  'BNS_API_PROJECTS_404_0001_CONTINUE_API__PROJECT_IS_INVALID',
  'BNS_API_USERS_400_0001_PASSWORD_API__CURRENT_PASSWORD_INCORRECT',
  'BNS_API_USERS_400_0002_PASSWORD_API__CURRENT_NEW_PASSWORD_REQUIRED',
  'BNS_API_USERS_400_0003_PASSWORD_INITIALIZE_API__PASSWORD_INITIALIZE_FAILURE',
  'BNS_API_USERS_400_0003_PASSWORD_RESET_API__PASSWORD_RESET_FAILURE',
  'BNS_API_WORKFLOWS_400_0001_WORKFLOW_API__STAGES_WITH_APPROVERS_ARE_REQUIRED',
  'BNS_API_WORKFLOWS_400_0001_WORKFLOW_API__STAGES_WITH_APPROVERS_ARE_REQUIRED',
  'BNS_API_PROJECTS_400_0058_ACTIVITY_FOR_SUB_PROJECT_API__SUB_PROJECT_UPDATE_WITH_RELATED_OBJECT',
  'BNS_API_PROJECTS_400_0059_ACTIVITY_FOR_SUB_PROJECT_API__SUB_PROJECT_DELETION_WITH_RELATED_OBJECT',
  'BNS_API_PROJECTS_400_0022_CORPORATE_NUMBER_SEARCH_API__TOO_MANY_RESULTS',
  'BNS_API_PROJECTS_400_0005_CONTINUE_API__PROJECT_IS_DISCARDED',
]);

export const ApiErrorCodeLabelModifier = {
  BNS_API_COMMENTS_400_0001_COMMENT_API__NOT_FOUND_IN_INPUT_CANDIDATE: t(
    'comment.error.message-not-found-in-input-candidate',
  ),
  BNS_API_COMMON_400_0001_INVALID_DATA: t('error-message-invalid-data'),
  BNS_API_COMMON_400_0002_UNIQUE_CONSTRAINT_ERROR: t(
    'error-message-unique-constraint-error',
  ),
  BNS_API_COMMON_400_0003_FOREIGN_KEY_CONSTRAINT_ERROR: t(
    'error-message-foreign-key-constraint',
  ),
  BNS_API_COMMON_400_0005_DB_PROTECTED_ERROR: t(
    'error-message-protected-error',
  ),
  BNS_API_COMMON_400_0007_DB_CODE_UNIQUE_VIOLATION_ERROR: t(
    'error-message-duplicated-code',
  ),
  BNS_API_COMMON_400_0008_INVALID_URL: t('error-message-invalid-url'),
  BNS_API_COMMON_403_0001_NOT_PERMITTED: t('error-message-not-permitted'),
  BNS_API_COMMON_403_0002_IP_RESTRICTED: t('error-message-ip-restricted'),
  BNS_API_COMMON_500_0001_INTERNAL_SERVER_ERROR: t(
    'error-message-internal-server-error',
  ),
  BNS_API_EXECUTIONS_400_0001_CREATE_CMS_NOTE_API__SLUG_DUPLICATED: t(
    'error-message-note-duplicate-slug',
  ),
  BNS_API_EXECUTIONS_400_0001_CREATE_EXECUTION_PROJECT_API__PROJECT_NOT_FOUND:
    t('error-message-execution-project-code-not-found'),
  BNS_API_EXECUTIONS_400_0002_CREATE_EXECUTION_CART_API__EXECUTION_CART_IDENTIFIER_NOT_FOUND:
    t('error-message-execution-cart-code-not-found'),
  BNS_API_EXECUTIONS_400_0002_PATCH_CMS_NOTE_BULK_UPDATE_API__NOTE_NOT_FOUND: t(
    'error-message-note-unexisting-note-is-included',
  ),
  BNS_API_EXECUTIONS_400_0003_CREATE_REVENUE_CHANGE_SOURCE_API__EXECUTION_CART_NOT_FOUND:
    t('error-message-selected-execution-cart-not-found'),
  BNS_API_EXECUTIONS_400_0003_PATCH_CMS_NOTE_API__PARENT_NOTE_IS_NOT_PUBLISHED:
    t('error-message-note-parent-note-is-not-published'),
  BNS_API_EXECUTIONS_400_0004_CREATE_EXECUTION_CART_API__EXPENDITURE_NATURE_NOT_FOUND:
    t(
      'error-message-execution-cart-expenditure-nature-external-system-code-incorrect',
    ),
  BNS_API_INDICATORS_400_0001_INDICATOR_API__SAME_TITLE_EXISTS: t(
    'error-message-indicators-same-title-exists',
  ),
  BNS_API_ORGANIZATIONS_400_0001_UPDATE_API__UPPER_ORGANIZATION_INCORRECT: t(
    'error-message-organizations-update-api-upper-organization-incorrect',
  ),
  BNS_API_PROJECTS_400_0001_CONTINUE_API__NO_INITIAL_BUDGET: t(
    'error-message-projects-continue-api-no-initial-budget',
  ),
  BNS_API_PROJECTS_400_0002_CONTINUE_API__PROJECT_IS_CONTINUED: t(
    'error-message-projects-continue-api-project-is-continued',
  ),
  BNS_API_PROJECTS_400_0006_SPLIT_API__PROJECT_IS_LOCKED: t(
    'error-message-projects-split-api-project-is-locked',
  ),
  BNS_API_PROJECTS_400_0007_MERGE_API__PROJECT_IS_LOCKED: t(
    'error-message-projects-merge-api-project-is-locked',
  ),
  BNS_API_PROJECTS_400_0008_SPLIT_API__PROJECT_IS_NEW: t(
    'error-message-projects-split-api-project-is-new',
  ),
  BNS_API_PROJECTS_400_0009_MERGE_API__PROJECT_IS_NEW: t(
    'error-message-projects-merge-api-project-is-new',
  ),
  BNS_API_PROJECTS_400_0010_MERGE_API__FISCAL_YEAR_MISMATCH: t(
    'error-message-projects-merge-api-fiscal-year-mismatch',
  ),
  BNS_API_PROJECTS_400_0011_MERGE_API__SHEET_TYPE_MISMATCH: t(
    'error-message-projects-merge-api-sheet-type-mismatch',
  ),
  BNS_API_PROJECTS_400_0012_MERGE_API__SAME_PROJECT: t(
    'error-message-projects-merge-api-same-project',
  ),
  BNS_API_PROJECTS_400_0013_DELETE_API__PROJECT_RELATION_EXIST: t(
    'error-message-projects-delete-api-project-relations',
  ),
  BNS_API_PROJECTS_400_0014_DECIDED_BUDGET_RELATED_API__DECIDED_BUDGET_BLOCK: t(
    'error-message-budget-api-budget-is-decided',
  ),
  BNS_API_PROJECTS_400_0016_NOTIFIED_BUDGET_RELATED_API__NOTIFIED_BUDGET_BLOCK:
    t('error-message-budget-api-budget-is-notified'),
  BNS_API_PROJECTS_400_0017_DECIDED_BUDGET_RELATED_API__DECIDE_BEFORE_NOTIFY: t(
    'error-message-budget-api-decide-before-notify',
  ),
  BNS_API_PROJECTS_400_0018_DECIDED_BUDGET_RELATED_API__RESET_NOTIFY_WITH_DECIDED_BUDGET:
    t('error-message-budget-api-reset-notify-with-decided-budget'),
  BNS_API_PROJECTS_400_0019_BATCH_API__SAME_BATCH_IS_RUNNING: t(
    'error-message-batch-api-same-batch-is-running',
  ),
  BNS_API_PROJECTS_400_0020_BUDGET_AGENDA_API__REQUESTING_BUDGET_BLOCK: t(
    'error-message-budget-agenda-requesting-budget',
  ),
  BNS_API_PROJECTS_400_0021_ACTIVITY_FLOW_MUST_BE_STARTED_FROM_ACTIVITY: t(
    'error-message-activity-flow-must-be-started-from-activity',
  ),
  BNS_API_PROJECTS_400_0029_PUBLISH_API__WORKFLOW_IS_NOT_COMPLETED: t(
    'error-message-publishing-error-with-uncompleted-workflow',
  ),
  BNS_API_PROJECTS_400_0031_PROJECT_API__EXPENDITURE_CART_MUST_HAVE_AT_LEAST_ONE_EXPENDITURE_ITEM:
    t('error-message-expenditure-cart-must-have-at-least-one-expenditure-item'),
  BNS_API_PROJECTS_400_0032_PROJECT_API__CANNOT_DELETE_EXPENDITURE_ITEM_BECAUSE_REVENUE_SOURCE_ITEM_EXISTS:
    t(
      'error-message-expenditure-cart-must-have-at-least-one-expenditure-item-delete',
    ),
  BNS_API_PROJECTS_400_0033_DECIDED_BUDGET_RELATED_API__RELATED_PROJECT_HAS_DELETED_USER:
    t('error-message-budget-api-decide-with-related-projects-has-deleted-user'),
  BNS_API_PROJECTS_400_0034_NOTIFIED_BUDGET_API__REQUESTING_BUDGET_BLOCK: t(
    'error-message-budget-api-notify-with-requesting-budget',
  ),
  BNS_API_PROJECTS_400_0035_PUBLISH_API__BUSINESS_MANAGER_DELETED: t(
    'error-message-publishing-error-with-deleted-business-manager',
  ),
  BNS_API_PROJECTS_400_0036_PUBLISH_API__PEOPLE_IN_CHARGE_DELETED: t(
    'error-message-publishing-error-with-deleted-people-in-charge',
  ),
  BNS_API_PROJECTS_400_0037_ANALYSIS_API__EXCEEDED_UPPER_LIMIT: t(
    'error-message-analysis-api-exceeded-upper-limit',
  ),
  BNS_API_PROJECTS_400_0038_SUB_PROJECT_STATUS_UPDATE_ERROR__NOTIFIED_BUDGET_BLOCK:
    t('error-message-sub-project-status-update-notified-budget-block'),
  BNS_API_PROJECTS_400_0039_SUB_PROJECT_STATUS_UPDATE_ERROR__NON_ZERO_LATEST_ASSESSMENT:
    t('error-message-sub-project-status-update-non-zero-latest-assessment'),
  BNS_API_PROJECTS_400_0040_ASSESSMENT_DELETE_ERROR__NOT_ZERO_IN_DISCONTINUED_SUB_PROJECT:
    t(
      'error-message-assessment-delete-not-zero-assessment-in-discontinued-sub-project',
    ),
  BNS_API_PROJECTS_400_0041_CONTINUE_API__REVENUE_SOURCE_ITEM_IS_CONTINUED: t(
    'error-message-revenue-continue-api-revenue-source-item-is-continued',
  ),
  BNS_API_PROJECTS_400_0042_CONTINUE_API__REVENUE_SOURCE_TYPE_IS_NOT_GENERAL: t(
    'error-message-revenue-continue-api-revenue-source-item-is-not-general',
  ),
  BNS_API_PROJECTS_400_0043_CONTINUE_API__BUDGET_STATUS_TYPE_IS_NOT_DECIDED: t(
    'error-message-revenue-continue-api-revenue-source-item-is-not-decided',
  ),
  BNS_API_PROJECTS_400_0044_SAVEPOINT_API_CREATE_ERROR__BUDGET_STATUS_HAS_ALREADY_BEEN_DECIDED:
    t('error-message-project-savepoint-create-api-budget-status-decided'),
  BNS_API_PROJECTS_400_0046_CONTINUE_API__BUDGET_STATUS_TYPE_IS_DISCONTINUED: t(
    'error-message-projects-continue-api-budget-status-is-discontinued',
  ),
  BNS_API_PROJECTS_400_0047_EXPENDITURE_CART_API_CREATE_ERROR__EXCEEDS_THE_MAXIMUM_NUMBER_OF_CARTS:
    t('error-message-projects-add-exceeds-the-maximum-number-of-carts'),
  BNS_API_PROJECTS_400_0048_SUB_PROJECT_API_MERGE_ERROR__EXCEEDS_THE_MAXIMUM_NUMBER_OF_CARTS:
    t('error-message-projects-move-exceeds-the-maximum-number-of-carts'),
  BNS_API_PROJECTS_400_0049_NOTIFIED_BUDGET_API__NULL_ASSESSING_AMOUNT_PROJECT_BLOCK:
    t(
      'error-message-budget-api-notify-with-null-assessing-amount-project-block',
    ),
  BNS_API_PROJECTS_400_0050_DISTRIBUTION_REQUEST_API__REQUESTED_AMOUNT_ALLOCATION_FAILED:
    t('error-message-distribution-request-amount-allocation-exceeded'),
  BNS_API_PROJECTS_400_0051_REVENUE_SOURCE_ITEM_CONTINUE_API__LOCKED_BY_BUDGET_STATUS:
    t('error-message-revenue-source-item-continue-by-locked'),
  BNS_API_PROJECTS_400_0052_NOTIFIED_BUDGET_API__NULL_ASSESSING_AMOUNT_REVENUE_SOURCE_ITEM_BLOCK:
    t(
      'error-message-budget-api-notify-with-null-assessing-amount-revenue-source-item-block',
    ),
  BNS_API_PROJECTS_400_0053_NOTIFIED_BUDGET_API__THERE_ARE_DISTRIBUTION_REQUESTS_THAT_CANNOT_BE_CANCELED:
    t(
      'error-message-notified-budget-api-there-are-distribution-requests-that-cannot-be-canceled',
    ),
  BNS_API_PROJECTS_400_0054_CARRIED_FORWARD_REQUEST_API__NO_PERMISSION_TO_UPDATE_STATUS:
    t('error-message-carried-forward-request-bulk-update-no-permission'),
  BNS_API_PROJECTS_400_0055_CARRIED_FORWARD_REQUEST_API__STATUS_IS_NOT_CHANGED:
    t('error-message-carried-forward-request-bulk-update-status-not-changed'),
  BNS_API_PROJECTS_400_0056_PROJECT_API__CANNOT_UPDATE_BASIC_INFO_WITHOUT_USER_ORGANIZATION_RELATION_TO_PROJECT:
    t('error-message-organizations-not-belong-to-my-organization'),
  BNS_API_PROJECTS_400_0057_CARRIED_FORWARD_REQUEST_API__NO_REGISTERED_CARRIED_FORWARD_AMOUNT:
    t(
      'error-message-carried-forward-request-no-carried-forward-amount-registered',
    ),
  BNS_API_PROJECTS_400_0060_REORGANIZE_SUB_PROJECT_API__PROJECT_IS_NOT_DECIDED:
    t('error-message-reorganize-sub-project-not-decided'),
  BNS_API_PROJECTS_400_0061_REORGANIZE_SUB_PROJECT_API__ALL_SUB_PROJECTS_MOVED:
    t('error-message-reorganize-sub-project-all-sub-projects-moved'),
  BNS_API_PROJECTS_400_0062_REORGANIZE_SUB_PROJECT_API__EXECUTION_CART_TRANSFER_FAILED:
    t('error-message-reorganize-sub-project-execution-cart-transfer-failed'),
  BNS_API_PROJECTS_400_0063_REORGANIZE_SUB_PROJECT_API__CARRY_FORWARD_IS_SET: t(
    'error-message-reorganize-sub-project-carry-forward-is-set',
  ),
  BNS_API_PROJECTS_404_0001_CONTINUE_API__PROJECT_IS_INVALID: t(
    'error-message-projects-continue-api-project-is-invalid',
  ),
  BNS_API_USERS_400_0001_PASSWORD_API__CURRENT_PASSWORD_INCORRECT: t(
    'error-message-users-password-api-current-password-incorrect',
  ),
  BNS_API_USERS_400_0002_PASSWORD_API__CURRENT_NEW_PASSWORD_REQUIRED: t(
    'error-message-users-password-api-current-new-password-required',
  ),
  BNS_API_USERS_400_0003_PASSWORD_INITIALIZE_API__PASSWORD_INITIALIZE_FAILURE:
    t('message-password-update-failed'),
  BNS_API_USERS_400_0003_PASSWORD_RESET_API__PASSWORD_RESET_FAILURE: t(
    'error-message-password-reset-failure',
  ),
  BNS_API_WORKFLOWS_400_0001_WORKFLOW_API__STAGES_WITH_APPROVERS_ARE_REQUIRED:
    t('error-message-workflows-stages-with-approvers-are-required'),
  BNS_API_PROJECTS_400_0058_ACTIVITY_FOR_SUB_PROJECT_API__SUB_PROJECT_UPDATE_WITH_RELATED_OBJECT:
    t(
      'error-message-activity-for-sub-project-cannot-update-sub-project-with-expenditure-cart',
    ),
  BNS_API_PROJECTS_400_0059_ACTIVITY_FOR_SUB_PROJECT_API__SUB_PROJECT_DELETION_WITH_RELATED_OBJECT:
    t(
      'error-message-activity-for-sub-project-cannot-delete-sub-project-with-expenditure-cart-or-activity',
    ),
  BNS_API_PROJECTS_400_0022_CORPORATE_NUMBER_SEARCH_API__TOO_MANY_RESULTS: t(
    'error-message-corporate-number-search-api-too-many-results',
  ),
  BNS_API_PROJECTS_400_0005_CONTINUE_API__PROJECT_IS_DISCARDED: t(
    'error-message-project-is-discarded',
  ),
} as const;
